import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../Assets/Finel-logo-PNG.png";

export default function Header(props) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const goFeatures = (e) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate("/#features");
      return;
    }
    props.scrollToFeatures?.();
  };

  const goSerendipity = (e) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate("/#serendipity");
      return;
    }
    props.scrollToSerendipity?.();
  };

  const goContact = (e) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate("/#contact");
      return;
    }
    props.scrollToFeedback?.();
  };

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 768) setMobileOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    // close menu on route change (including hash updates)
    setMobileOpen(false);
  }, [location.pathname, location.hash]);

  const navLinks = (
    <>
      <Link
        className="rounded-xl px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 hover:text-slate-900"
        to="/"
        onClick={props.scrollToHome}
      >
        Home
      </Link>
      <Link
        className="rounded-xl px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 hover:text-slate-900"
        to="/#features"
        onClick={goFeatures}
      >
        Features
      </Link>
      <Link
        className="rounded-xl px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 hover:text-slate-900"
        to="/#serendipity"
        onClick={goSerendipity}
      >
        Serendipity
      </Link>
      <Link
        className="rounded-xl px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 hover:text-slate-900"
        to="/blogs"
        onClick={() => window.scrollTo(0, 0)}
      >
        Blog
      </Link>
      <Link
        className="rounded-xl px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 hover:text-slate-900"
        to="/#contact"
        onClick={goContact}
      >
        Contact
      </Link>
    </>
  );

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        {/* <div className="h-16 flex items-center justify-between md:grid md:grid-cols-3"> */}
        <div
  className={`h-16 flex items-center ${
    mobileOpen ? "justify-end" : "justify-between"
  } md:grid md:grid-cols-3`}
>
          {/* Left: Logo */}
          <Link
  to="/"
  onClick={props.scrollToHome}
  className={`flex items-center ${
    mobileOpen ? "hidden" : "block"
  } md:justify-self-start`}
>
  <img src={Logo} alt="BSI" className="h-8 w-auto md:h-9" />
</Link>
          {/* <Link
            to="/"
            onClick={props.scrollToHome}
            className="flex items-center justify-start md:justify-self-start"
          >
            <img src={Logo} alt="BSI" className="h-8 w-auto md:h-9 md:hidden" />
          </Link> */}

          {/* Center: Menu (desktop) */}
          <nav className="hidden md:flex items-center justify-center gap-2 md:justify-self-center">
            {navLinks}
          </nav>

          {/* Right: CTA (desktop) + Hamburger (mobile) */}
          <div className="flex items-center justify-end md:justify-self-end">
            <Link
              to="/signup"
              className="hidden md:inline-flex min-w-[132px] items-center justify-center whitespace-nowrap rounded-full px-5 py-2 text-sm font-semibold text-white shadow-[0_14px_30px_rgba(0,114,255,0.22)] hover:brightness-95"
              style={{
                backgroundImage:
                  "linear-gradient(90deg, #00C6FF 0%, #0072FF 100%)",
              }}
            >
              Get Started
            </Link>

            <button
              type="button"
              className="md:hidden inline-flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-700 shadow-sm"
              aria-label={mobileOpen ? "Close menu" : "Open menu"}
              aria-expanded={mobileOpen ? "true" : "false"}
              onClick={() => setMobileOpen((v) => !v)}
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="h-5 w-5"
              >
                {mobileOpen ? (
                  <path d="M18 6 6 18M6 6l12 12" />
                ) : (
                  <path d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile dropdown (smooth slide) */}
      <div
        className={[
          "md:hidden overflow-hidden border-t border-slate-200 bg-white/95 backdrop-blur-md",
          "transition-[max-height,opacity] duration-300 ease-out",
          mobileOpen ? "max-h-[420px] opacity-100" : "max-h-0 opacity-0",
        ].join(" ")}
      >
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 py-4">
          {/* Logo inside menu */}
          <Link
            to="/"
            onClick={props.scrollToHome}
            className="flex items-center justify-start pb-3"
          >
            <img src="" alt="BSI" className="h-9 w-auto" />
          </Link>

          <nav className="flex flex-col gap-1">
            {navLinks}
            <Link
              to="/signup"
              className="mt-3 inline-flex min-h-11 items-center justify-center whitespace-nowrap rounded-full px-5 py-2.5 text-sm font-semibold text-white shadow-[0_14px_30px_rgba(0,114,255,0.22)]"
              style={{
                backgroundImage:
                  "linear-gradient(90deg, #00C6FF 0%, #0072FF 100%)",
              }}
            >
              Get Started
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
}
